<template>
  <div v-if="produitCollection" :class="jel_getClassObject(content)">
    <b-container v-if="arrayIdProduit" fluid class="menu-droit mw-100 p-0 d-flex-column mt-1">
      <b-row class="mw-100 m-0 border-bottom">
        <b-col cols="12" class="px-0">
          <div v-if="afficherFlechesNavigation" class="navigation">
            <b-button v-if="positionListe > 0" class="fleche gauche" @click="scrollListeAGauche()">
              <svg-icon scale="0.7" icon-name="fleche-gauche" />
            </b-button>
            <b-button
              v-if="afficherFlecheDroite"
              class="fleche droite"
              @click="scrollListeADroite()"
            >
              <svg-icon class="rotation180" scale="0.7" icon-name="fleche-gauche" />
            </b-button>
          </div>
          <div
            ref="liste-collections"
            class="liste-boutons-collections d-flex overflow-auto py-1 ml-2"
          >
            <b-button
              v-for="(produit, index) in produitCollection"
              :key="produit['@id']"
              :ref="produitCollection[index]['@name']"
              pill
              class="bouton-collection mb-0 mr-1 px-2 py-1"
              :class="{
                'bouton-actif': listeAffichee == index,
                'd-none': !isBonEtatConnexion(index),
              }"
              @click="[(listeAffichee = index), getPrefs(index)]"
              @click.capture="gaPreventClick(index)"
              >{{ libBouton(index) }}
            </b-button>
          </div>
          <div
            v-if="afficherFlechesNavigation"
            class="degrade position-absolute w-100 h-100"
            :class="afficherFlecheDroite ? 'droite' : 'gauche'"
          />
        </b-col>
        <b-col
          v-for="(uuidProduit, index) in arrayIdProduit[listeAffichee]"
          :key="index"
          class="col-6 itemCollection liste-2-colonnes"
          :class="index % 2 == 0 ? 'pr-0 pl-1' : 'pl-0 pr-1'"
        >
          <MediaImageLogoProduitCasino3x4 :content="{ idProduit: uuidProduit }" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from '@/js/i18n';

import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

import MediaImageLogoProduitCasino3x4 from '@/components/casino/media/image/MediaImageLogoProduitCasino3x4';

import session from '@/services/api/compte/session';

export default {
  name: 'CollectionCasinoListe',
  components: {
    MediaImageLogoProduitCasino3x4,
  },
  props: {
    content: { type: Object, required: true },
  },
  data() {
    return {
      listeAffichee: 0,
      positionListe: 0,
      scrollOverflow: 0,
      afficherFlecheDroite: true,
      marginBorderBouton: 10, // 10px (le margin et les borders du bouton de collection)
    };
  },
  computed: {
    ...mapGetters({
      getByUuid: 'produitCollection/getByUuid',
      getArrayIdProduitCasinoByProduitCollection:
        'produitCasino/getArrayIdProduitCasinoByProduitCollection',
    }),
    // TODO: Traiter CED
    produitCollection() {
      const filtreListeProduitCollection = [];
      this.content.listeProduitCollection['@nodes'].forEach((item) => {
        filtreListeProduitCollection.push({
          ...this.getByUuid(this.content.listeProduitCollection[item].idProduitCollection),
          libBouton: this.content.listeProduitCollection[item].libBouton,
          affichageConnexion: this.content.listeProduitCollection[item].affichageConnexion,
          specialite: this.content.listeProduitCollection[item].specialite,
        });
      });
      return filtreListeProduitCollection;
    },
    arrayIdProduit() {
      // TODO: Améliorer la logique afin de ne pas obtenir toutes les listes dès le départ
      const listeArrayIdProduit = [];
      this.produitCollection.forEach((item) => {
        listeArrayIdProduit.push(
          this.getArrayIdProduitCasinoByProduitCollection(item).slice(
            0,
            this.content.nbMaxElementAffiche ??
              process.env.VUE_APP_LISTE_HORIZONTALE_NB_MAX_ELEMENT_AFFICHE
          )
        );
      });
      return listeArrayIdProduit;
    },
    isSessionOuverte() {
      return session.sessionEstOuverte();
    },
    listeCollection() {
      return this.$refs['liste-collections'];
    },
  },
  activated() {
    this.positionListe = 0;
    this.scrollOverflow = 0;
    this.afficherFlecheDroite = true;
  },
  methods: {
    gaPreventClick(index = null, evt = null) {
      let event = '';
      let categorie = '';
      let libelle = '';

      // On récupère le titre du Jeu
      const listeTitreProduit = document.getElementsByClassName('titreJeu');
      const titreProduit = listeTitreProduit[0].textContent;

      event = 'ga-tc-click';
      categorie = 'TC - Tag collection';
      libelle += `Jeu ${titreProduit} - TC ${this.libBouton(index)}`;
      const emplacement = `${this.jel_gaGetEmplacement()} ${titreProduit}`;
      const position = index + 1;

      // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
      gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
        event,
        categorie,
        emplacement,
        libelle,
        position,
      });
    },

    getPrefs(index) {
      if (this.specialite(index) === 'favoris' || this.specialite(index) === 'jouesRecemment') {
        this.$store.dispatch('preferences/getPreferences');
      }
    },
    afficherFlechesNavigation() {
      return this.listeCollection
        ? this.listeCollection.clientWidth > this.listeCollection.scrollWidth
        : false;
    },
    scrollListeADroite() {
      const horizontalScrollWidth =
        this.listeCollection.scrollWidth - this.listeCollection.clientWidth;
      /**
       * Tant que la collection n'est pas affichée (clientWidth à 0)
       * exemple: Collections favoris et joués récemment en mode déconnecté
       * => on incrémente la position dans la collection
       * */
      while (
        this.positionListe < this.produitCollection.length &&
        this.$refs[this.produitCollection[this.positionListe]['@name']] &&
        this.$refs[this.produitCollection[this.positionListe]['@name']][0].clientWidth == 0
      ) {
        this.positionListe++;
      }
      // On ajoute le margin et les borders à la largeur du bouton de collection
      const boutonWidth = this.largeurBouton(this.positionListe) + this.marginBorderBouton;
      if (this.listeCollection.scrollLeft + boutonWidth > horizontalScrollWidth) {
        this.scrollOverflow = this.listeCollection.scrollLeft + boutonWidth - horizontalScrollWidth;
        this.afficherFlecheDroite = false;
      } else if (this.listeCollection.scrollLeft + boutonWidth == horizontalScrollWidth) {
        this.afficherFlecheDroite = false;
      }
      this.listeCollection.scrollLeft += boutonWidth;
      this.positionListe++;
    },
    scrollListeAGauche() {
      const horizontalScrollWidth =
        this.listeCollection.scrollWidth - this.listeCollection.clientWidth;
      this.positionListe--;
      // On ajoute le margin et les borders à la largeur du bouton de collection
      let boutonWidth = this.largeurBouton(this.positionListe) + this.marginBorderBouton;
      if (this.scrollOverflow > 0) {
        boutonWidth -= this.scrollOverflow;
        this.scrollOverflow = 0;
      }
      if (!this.afficherFlecheDroite) this.afficherFlecheDroite = true;
      this.listeCollection.scrollLeft -= boutonWidth;
      /**
       * Tant que la collection précédente n'est pas affichée (clientWidth à 0)
       * exemple: Collections favoris et joués récemment en mode déconnecté
       * => on décrémente la position dans la collection
       * */
      while (
        this.positionListe > 0 &&
        this.$refs[this.produitCollection[this.positionListe - 1]['@name']] &&
        this.$refs[this.produitCollection[this.positionListe - 1]['@name']][0].clientWidth == 0
      ) {
        this.positionListe--;
      }
    },
    largeurBouton(pos) {
      if (!this.$refs[this.produitCollection[pos]['@name']]) {
        return 52; /* Bouton 'Tout' : 4 caracteres de 13px (52 px)  */
      }
      if (
        this.$refs[this.produitCollection[pos]['@name']] &&
        this.$refs[this.produitCollection[pos]['@name']][0].clientWidth != 0
      ) {
        return this.$refs[this.produitCollection[pos]['@name']][0].clientWidth;
      }
      return 0;
    },
    specialite(index) {
      if (this.produitCollection[index].specialite) {
        return this.produitCollection[index].specialite;
      }
      return '';
    },
    libBouton(index) {
      if (this.produitCollection[index].libBouton) {
        return this.produitCollection[index].libBouton;
      }

      return i18n.locale == 'en'
        ? this.produitCollection[index].titreCollectionEn
        : this.produitCollection[index].titreCollectionFr;
    },
    isBonEtatConnexion(index) {
      if (this.produitCollection[index].affichageConnexion) {
        if (
          (this.produitCollection[index].affichageConnexion == 'connecte' &&
            !this.isSessionOuverte) ||
          (this.produitCollection[index].affichageConnexion == 'deconnecte' &&
            this.isSessionOuverte)
        ) {
          if (this.listeAffichee < 2 && index < 2) {
            this.listeAffichee = index + 1;
          }
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  display: flex;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
}
.caracteristiques {
  text-transform: uppercase;
  font-size: 0.8125rem;
  line-height: 0.9375rem;
  color: $noir-casino;
  opacity: 0.75;
}

.liste-boutons-collections {
  display: block;
  overflow: hidden;
  scroll-behavior: smooth;
  white-space: nowrap;

  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
}
.bouton-collection {
  z-index: 1;
}
.fleche {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white !important;
  z-index: 2;
  border-color: $gris-pale-casino !important;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);

  svg {
    fill: $gris-casino;
    width: 0.7em;
    height: 0.7em;
  }
  &:hover,
  &:focus {
    box-shadow: none !important;
  }
}
.gauche {
  margin-left: 8px;
}
.droite {
  margin-left: auto;
  margin-right: 4px;
}

.itemCollection {
  border-bottom: 1px solid $gris-pale-casino;
  &:last-child,
  &.pr-1:nth-last-child(2) {
    border: none;
  }
}
.degrade {
  pointer-events: none;
  top: 0;
  z-index: 1;

  &.droite {
    background: linear-gradient(to right, rgba(0, 0, 0, 0) 80%, #fff 90%);
  }
  &.gauche {
    background: linear-gradient(to left, rgba(0, 0, 0, 0) 80%, #fff 95%);
  }
}
</style>
